import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { type ErroApi } from '@/nucleo/auth/cliente-api';
import { naoInsistirEmRecusa } from '@/nucleo/naoInsistirEmRecusa';

/**
 * A camada de dados do SLA de aprovação SME.
 *
 * Mesmo desenho das outras telas: nenhum componente chama `chamarApi` direto, e a
 * chave de cache mora junto de quem a usa (CLAUDE.md, "Regras de API").
 *
 * TEMPORÁRIO — mock local, remover no desenvolvimento do backend.
 * `/configuracoes/sla-aprovacao-sme` ainda não existe na API — hoje
 * `apps/api/src/modulos/` só tem `eu`, `govbr` e `senha`. Decisão do dono de
 * 2026-08-26 (CLAUDE.md, "Proibido", exceção estendida) para demonstração ao
 * cliente — mesmas três condições dos cinco módulos de cadastro: só leitura,
 * dado claramente fictício, removido antes de `develop` → `hml` (`git grep -n
 * "TEMPORÁRIO" apps/web/src`, checklist em `docs/ALVOS.md`). O valor abaixo é o
 * próprio padrão confirmado pelo cliente (não é dado inventado, só a busca por
 * ele que é mockada); "Salvar" continua sem gravar nada — ver
 * `SlaAprovacaoSmePage.tsx`.
 */

export const CHAVE_SLA_APROVACAO_SME = ['configuracoes', 'sla-aprovacao-sme'] as const;

/**
 * Prazo padrão, em dias úteis, que a SME tem para aprovar ou devolver um lote
 * enviado pela DRE.
 *
 * Fato de negócio confirmado pelo cliente em 11/06/2026 — não é dado fictício.
 * Repetido aqui, e não lido de um `lib/sla.ts` compartilhado, porque esse arquivo
 * pertence à apuração mensal (Fase 5) e ainda não existe neste repositório.
 */
export const SLA_APROVACAO_SME_DIAS_UTEIS_PADRAO = 2;

export interface SlaAprovacaoSmeResposta {
  diasUteis: number;
}

/**
 * O prazo de aprovação SME configurado hoje.
 *
 * TEMPORÁRIO — mock local, remover no desenvolvimento do backend: devolve o
 * padrão confirmado pelo cliente em vez de buscar na API, que ainda não existe.
 */
export function useSlaAprovacaoSme(): UseQueryResult<SlaAprovacaoSmeResposta, ErroApi> {
  return useQuery<SlaAprovacaoSmeResposta, ErroApi>({
    queryKey: CHAVE_SLA_APROVACAO_SME,
    queryFn: async () => ({ diasUteis: SLA_APROVACAO_SME_DIAS_UTEIS_PADRAO }),
    retry: naoInsistirEmRecusa,
  });
}
